const roles = {
  bankAdmin: 'Administrador de Usuarios Banco',
  bankUsersAnalyst: 'Analista Usuarios Banco',
  supervisorBank: 'Supervisor Banco',
  correspondentAnalyst: 'Analista Banco',
  bankConsultant: 'Consultas Banco',
  correspondentAdmin: 'Administrador Corresponsal',
  correspondentConsultant: 'Consultas Corresponsal',
  correspondentSupervisor: 'Supervisor sucursal',
  cashierCorporate: 'Cajero Corresponsal Corporativo',
  cashierPersonal: 'Cajero Corresponsal Unipersonal',
  rotativeSupervisor: 'Supervisor rotatorio Corresponsal',
} as const;

const correspondentTypes = {
  corporateCorrespondent: 'Corporativo',
  smallCorrespondent: 'Corresponsal pequeño WEB',
  smallCorrespondentYOLO: 'Corresponsal Pequeño Yolo',
} as const;

const reportTransactionTypes = {
  analystCorrespondent: 'isAnalystCorrespondent',
  adminCorrespondent: 'isAdminCorrespondent',
  correspondentConsultant: 'isCorrespondentConsultant',
} as const;

const adminRoles = [roles.correspondentAdmin, roles.rotativeSupervisor] as const;

const status = [
  { id: 0, value: 'Todos' },
  { id: 1, value: 'Pendiente' },
  { id: 2, value: 'En curso' },
  { id: 3, value: 'Aprobada' },
  { id: 4, value: 'Rechazado' },
] as const;

export { adminRoles, correspondentTypes, reportTransactionTypes, roles, status };
